import React from 'react';
import { useDispatch } from 'react-redux';
import { setCurrentScreen } from '../../store/orderSlice';
import Button from '../ui/Button';
import PromotionImage from '../../data/PanaImages/PromotionImage.jpg';

const WelcomeScreen: React.FC = () => {
  const dispatch = useDispatch();
  const handleStartOrder = () => {
    dispatch(setCurrentScreen('loyalty'));
  };

  return (
    <div
      className="flex flex-col min-h-screen w-screen bg-[#e9e6df]"
      onClick={handleStartOrder}
    >
      {/* Hero area - promotion image fills the top */}
      <div className="relative flex-1 w-full overflow-hidden">
        <img
          src={PromotionImage}
          alt="Promotion"
          className="absolute inset-0 h-full w-full object-cover"
          draggable={false}
        />
      </div>

      {/* Footer area with CTA */}
      <div className="w-full bg-[#FFFFFF] pt-10 pb-14 px-8 shadow-[0_-8px_16px_rgba(0,0,0,0.12)]">
        <div className="mx-auto flex max-w-[1080px] flex-col items-center">
          <Button
            variant="primary"
            size="xl"
            onClick={handleStartOrder}
            className="w-[72%] rounded-tl-none rounded-tr-[28px] rounded-bl-[28px] rounded-br-none px-[64px] py-[24px] shadow-[0_16px_24px_rgba(0,0,0,0.22)]"
          >
            <span className="flex flex-col items-center leading-tight">
              <span className="uppercase tracking-[2.5px] text-[36px] font-display font-black">Start Your Order</span>
              <span className="mt-1 text-white/95 text-[24px] font-dancing font-medium">Experience our delicious Italian cuisine</span>
            </span>
          </Button>

          
          <p
            className="mt-6 text-center"
            style={{
              fontFamily: '"Museo Sans", ui-sans-serif, system-ui, -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, Oxygen, Ubuntu, Cantarell, "Fira Sans", "Droid Sans", "Helvetica Neue", sans-serif',
              fontSize: '25px',
              color: '#B1B1AF',
            }}
          >
            Tap anywhere to Begin
          </p>
        </div>
      </div>

    </div>
  );
};

export default WelcomeScreen;